import { useState, useEffect } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { getLDClientId } from '../utils/getLdClientId';

export function useBootstrapLD(env, flagName, userId) {
  const [flag, setFlag] = useState(null);
  const [flagReady, setFlagReady] = useState(false);
  useEffect(() => {
    if (env) {
      const clientId = getLDClientId(env.name);
      const ldclient = LDClient.initialize(clientId, {
        key: userId || 'anonymous',
      });
      ldclient.on(`change:${flagName}`, (value, previous) => {
        setFlag(value);
      });
      ldclient.on('ready', () => {
        const ldFlag = ldclient.variation(flagName, false);
        setFlag(ldFlag);
        setFlagReady(true);
      });
    }
  }, [env, userId]); // eslint-disable-line react-hooks/exhaustive-deps
  return { flag, flagReady };
}

export default useBootstrapLD;
